@if (packLimitationService.isDiscovery()) {
  <button
    class="w-full rounded-lg border border-greyscale-200 bg-greyscale-50 p-4 transition-all duration-200 hover:border-greyscale-300 hover:bg-greyscale-100"
    (click)="openContactModal()"
    [pTooltip]="'discovery.upgrade' | transloco"
  >
    <!-- Header avec badge -->
    <div class="mb-3 flex items-center justify-between">
      <div class="flex items-center gap-2">
        <lucide-icon name="flask-conical" [size]="20" class="text-primary-600">
        </lucide-icon>
        <h4 class="text-paragraph-s-med font-semibold text-greyscale-800">
          {{ "discovery.progress.modeDiscovery" | transloco }}
        </h4>
      </div>
    </div>

    <!-- Progress Bar -->
    <div class="mb-3">
      <p-progressBar
        [value]="progressPercentage"
        [style]="{ height: '8px' }"
        [showValue]="false"
        [dt]="{ valueBackground: '{primary.300}', background: '{gray.200}' }"
      >
      </p-progressBar>
    </div>

    <!-- Compteur et statut -->
    <div class="flex items-center justify-between">
      <span class="text-paragraph-xs-reg text-greyscale-700">
        {{
          "discovery.progress.tripsUsed"
            | transloco
              : {
                  used: tripUsed,
                  limit: tripLimit,
                }
        }}
      </span>

      @if (isLimitReached) {
        <div
          class="text-paragraph-xs-med text-primary-600 underline transition-colors duration-200 hover:text-primary-700"
        >
          {{ "discovery.progress.contactUs" | transloco }}
        </div>
      } @else {
        <span class="text-paragraph-xs-reg font-medium text-validation-600">
          {{
            "discovery.progress.remaining"
              | transloco
                : {
                    count: tripLimit - tripUsed,
                  }
          }}
        </span>
      }
    </div>

    <!-- Message d'encouragement si limite proche -->
    @if (progressPercentage >= 65 && !isLimitReached) {
      <div class="mt-3 rounded border border-warning-200 bg-warning-50 p-2">
        <p class="text-paragraph-xs-reg text-warning-800">
          {{ "discovery.progress.warningMessage" | transloco }}
        </p>
      </div>
    }
  </button>
}
